<template>
	<div class="bg-primary-25 w-full p-6 print:py-2">
		<section>
			<h2
				class="form-title pb-6 text-2xl font-bold print:mb-3 print:border-b-2 print:border-slate-900 print:pt-2 print:pb-3 print:text-sm/0"
			>
				{{ t('plan.sectionTitle.parents') }}
			</h2>
			<FormKit
				id="fatherInfo"
				name="fatherInfo"
				type="group"
			>
				<div
					class="section-grid-row grid grid-cols-3 gap-2 *:w-full *:max-w-none"
				>
					<FormKit
						type="textarea"
						auto-height
						name="firstName"
						:label="t('plan.fatherInfo.firstName')"
					/>

					<FormKit
						type="textarea"
						auto-height
						name="middleName"
						:label="t('plan.fatherInfo.middleName')"
					/>

					<FormKit
						type="textarea"
						auto-height
						name="lastName"
						:label="t('plan.fatherInfo.lastName')"
					/>
				</div>

				<BirthLocationForm :model="plan.fatherInfo" />
			</FormKit>

			<FormKit
				id="motherInfo"
				name="motherInfo"
				type="group"
			>
				<div
					class="section-grid-row grid grid-cols-3 gap-2 *:w-full *:max-w-none"
				>
					<FormKit
						type="textarea"
						auto-height
						name="firstName"
						:label="t('plan.motherInfo.firstName')"
					/>

					<FormKit
						type="textarea"
						auto-height
						name="middleName"
						:label="t('plan.motherInfo.middleName')"
					/>

					<FormKit
						type="textarea"
						auto-height
						name="maidenName"
						:label="t('plan.motherInfo.maidenName')"
					/>
				</div>

				<BirthLocationForm :model="plan.motherInfo" />
			</FormKit>

			<div
				class="section-grid-row grid grid-cols-1 *:w-full *:max-w-none *:px-1"
				:class="{ 'print:hidden': !plan?.parentalInfoNotes?.trim() }"
			>
				<FormKit
					type="textarea"
					auto-height
					name="parentalInfoNotes"
					:label="t('plan.notes')"
					:outer-class="{ 'mb-0': true }"
					:placeholder="t('plan.placeholders.parentalInfoNotes')"
					validation="length:0,10000"
					validation-visibility="live"
				/>
			</div>
		</section>
	</div>
</template>

<script setup lang="ts">
import BirthLocationForm from './BirthLocationForm.vue'
import type Plan from '@/classes/Plan'
import { usePresentationLocale } from '@/i18n'
import { FormKit } from '@formkit/vue'

const { t } = usePresentationLocale()

const props = defineProps<{
	activePlanIndex: number
	plan: Plan
}>()
</script>
